
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import store from './store';
import Datepicker from 'vuejs-datepicker';
import VueI18n from 'vue-i18n';
import VueQuillEditor from 'vue-quill-editor';
import VTooltip from 'v-tooltip'

// Stand-alone components used on other parts of the site
Vue.component('site-image-loader', require('./components/SiteImageLoader.vue'));

// Schedule components
Vue.component('schedule', require('./components/schedule/Schedule.vue'));
Vue.component('event', require('./components/schedule/Event.vue'));

// Backend components used in the page editor
Vue.component('default-page', require('./components/DefaultPage.vue'));
Vue.component('default-block', require('./components/blocks/DefaultBlock.vue'));
Vue.component('separator-block', require('./components/blocks/SeparatorBlock.vue'));

Vue.component('paragraph-widget', require('./components/widgets/ParagraphWidget.vue'));
Vue.component('header-widget', require('./components/widgets/HeaderWidget.vue'));
Vue.component('image-widget', require('./components/widgets/ImageWidget.vue'));
Vue.component('file-widget', require('./components/widgets/FileWidget.vue'));
Vue.component('html-widget', require('./components/widgets/HtmlWidget.vue'));

Vue.component('block-options', require('./components/helpers/BlockOptions.vue'));
Vue.component('datepicker', Datepicker);

Vue.use(VTooltip);

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VueI18n);

// Used to close the blocks when clicking outside them
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his childrens
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        // Using mouseup because the click event is stopped by the blocks
        document.body.addEventListener('mouseup', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('mouseup', el.clickOutsideEvent)
    },
});

const lang = require('./lang/Messages.js');

var messages = lang.messages;

const i18n = new VueI18n({
    locale: document.locale, // set locale
    fallbackLocale: 'ru', // set fallback locale
    messages, // set locale messages
});

const app = new Vue({
    i18n,
    el: '#app',
    store: store,
});


// WEBPACK FOOTER //
// ./resources/js/app.js